import React, { useState, useEffect, useCallback, useMemo } from 'react';
import '../css/user/feed.css';
import SubscribeModalLoggedIn from '../../../views/Modals/SubscribeModal/SubscribeModalLoggedIn';
import { checkPromotion } from '../../../shared/actions/promotionAction';
import { getDiscountOfferText, getPromotionRemainingText, getRedeemOfferTypeLabel } from '../../../shared/utils/paymentUtil';
import { ROLE } from '../../../shared/constants/common';
import { isUserLoggedIn } from '../../../shared/utils/function';

const LockedMonthlyContentPreview = ({
  creatorInfo = null,
  onSubscriptionSuccess,
}) => {
  const [promotionData, setPromotionData] = useState(null);
  const loggedIn = isUserLoggedIn();

  const fetchPromotionData = useCallback(async () => {
    if (!creatorInfo?._id) return;
    try {
      const result = await checkPromotion(creatorInfo._id);
      if (result.success && result.data) {
        if (result.data.eligible && result?.data?.promo) {
          setPromotionData(result.data.promo);
        } else {
          setPromotionData(null);
        }
      }
    } catch (error) {
      setPromotionData(null);
    }
  }, [creatorInfo?._id]);

  useEffect(() => {
    if (creatorInfo?.rol === ROLE.CREATOR_SUB) {
      if (loggedIn) {
        fetchPromotionData();
      } else if (creatorInfo?.active_promotion) {
        setPromotionData({ ...creatorInfo.active_promotion, active: true });
      } else {
        setPromotionData(null);
      }
    }
  }, [creatorInfo?.rol, creatorInfo?.active_promotion, loggedIn, fetchPromotionData]);

  const promotionText = useMemo(() => getDiscountOfferText(promotionData), [promotionData]);
  const promotionRemainingText = useMemo(() => getPromotionRemainingText(promotionData), [promotionData]);
  const redeemOfferTypeLabel = useMemo(() => getRedeemOfferTypeLabel(promotionData), [promotionData]);
  const btnText = useMemo(
    () => (promotionText && promotionRemainingText?.isValid
      ? (redeemOfferTypeLabel ? `Redeem ${redeemOfferTypeLabel}` : 'Redeem')
      : 'Subscribe'),
    [promotionText, promotionRemainingText, redeemOfferTypeLabel]
  );

  return (
    <>
      <div className="post-media-container" style={{ position: 'relative' }}>
        {/* Blurred background preview */}
        <div className="lock-overlay">
          <div className="lock-content-box">
            <div className="lock-user-profile">
              <div className="lock-avatar">
                <i className="fa-solid fa-lock" style={{ fontSize: '48px', color: '#ffffff' }}></i>
              </div>
            </div>

            <div>
              <div className="unlock-text-title">
                Exclusive Content
              </div>

              <div className="unlock-text-subtitle">
              Subscribe to unlock premium posts and 1-on-1 chat or call access with this creator.
              </div>
            </div>

            <SubscribeModalLoggedIn
              creatorInfo={creatorInfo}
              btnText={btnText}
              handleCallback={onSubscriptionSuccess}
              renderTrigger={({ onClick, isDisabled, btnText: triggerBtnText, loggedIn: isLoggedIn, subscribeBtn: onSignInRequired }) => (
                <button
                  className="purchase-button"
                  onClick={(event) => {
                    event.preventDefault();
                    if (isDisabled) return;
                    if (isLoggedIn && typeof onClick === 'function') {
                      onClick();
                    } else if (!isLoggedIn && typeof onSignInRequired === 'function') {
                      onSignInRequired();
                    }
                  }}
                  type="button"
                  disabled={isDisabled}
                >
                  {triggerBtnText}
                </button>
              )}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default LockedMonthlyContentPreview;
